import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5 11H3.5C3.36739 11 3.24021 10.842 3.14645 10.5607C3.05268 10.2794 3 9.89782 3 9.5V6.5C3 6.10218 3.05268 5.72064 3.14645 5.43934C3.24021 5.15803 3.36739 5 3.5 5H20.5C20.6326 5 20.7598 5.15803 20.8536 5.43934C20.9473 5.72064 21 6.10218 21 6.5V9.5C21 9.89782 20.9473 10.2794 20.8536 10.5607C20.7598 10.842 20.6326 11 20.5 11ZM8.64001 15.85C8.57091 15.7795 8.52422 15.6901 8.50582 15.5931C8.48743 15.4962 8.49816 15.3959 8.53666 15.305C8.57516 15.2141 8.6397 15.1366 8.72216 15.0823C8.80462 15.0281 8.90129 14.9994 9.00001 15H11V12.5C11 12.3674 11.0527 12.2402 11.1465 12.1464C11.2402 12.0527 11.3674 12 11.5 12H12.5C12.6326 12 12.7598 12.0527 12.8536 12.1464C12.9473 12.2402 13 12.3674 13 12.5V15H15C15.0979 15.0014 15.1932 15.0314 15.2741 15.0865C15.3551 15.1415 15.4181 15.2191 15.4553 15.3096C15.4926 15.4001 15.5025 15.4995 15.4838 15.5956C15.465 15.6917 15.4185 15.7801 15.35 15.85L12.35 18.85C12.2549 18.9422 12.1275 18.9938 11.995 18.9938C11.8625 18.9938 11.7352 18.9422 11.64 18.85L8.64001 15.85Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgVerticalAlignBottom = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgVerticalAlignBottom;
